import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmPopup = ({
  showModal,
  onCloseColorSlot,
  onSaveSlotData,
  title = "Confirm Reset?",
  message = "Do you want to revert all changes to the last Save?",
}) => {
  return (
    <Modal
      show={showModal}
      onHide={onCloseColorSlot}
      backdrop="static"
      contentClassName="confirmPopupContent"
      dialogClassName="confirmPopupDialog"
      backdropClassName="confirmPopupBackDrop"
    >
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button size="sm" variant="secondary" onClick={onCloseColorSlot}>
          Cancel
        </Button>
        <Button
          size="sm"
          variant="primary"
          onClick={() => {
            onSaveSlotData();
            onCloseColorSlot();
          }}
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmPopup;
